import WNCharLimitCounter from './WNCharLimitCounter';

const WNInput = (props: WNInputProps) => {
  const {
    id,
    label,
    placeholder,
    value,
    optionalClass,
    onBlur,
    onChange,
    charLimit,
    autoFocus,
    disabled,
  } = props;

  const isPassword = () => {
    return label.toLocaleLowerCase().includes('password');
  };

  return (
    <div className="input-wrapper">
      <div className="input-label-group">
        <label htmlFor={label} className="input-label">
          {label}
        </label>
        {charLimit && (
          <WNCharLimitCounter charLength={value.length} charLimit={charLimit} />
        )}
      </div>
      <input
        id={id}
        value={value}
        placeholder={placeholder}
        aria-label={label}
        className={'body2 wilderNet-input ' + optionalClass}
        type={isPassword() ? 'password' : 'text'}
        autoComplete={label}
        onBlur={onBlur}
        onChange={onChange}
        maxLength={charLimit}
        autoFocus={autoFocus}
        disabled={disabled}
      />
    </div>
  );
};

export default WNInput;
